<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 公司简介
    </div>
    <div class="common_wrap">
      <img src="../../static/images/aboutus.jpg" class="top_banner">
      <div class="about_lists">
        <div class="about_item">
          <p class="about_title">
            <span class="num">1</span>
            <span>帝景</span>
          </p>
          <div class="about_text">上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球典范品质的纯进口卫浴产品及一站式系统服务。</div>
        </div>
        <div class="about_item">
          <p class="about_title">
            <span class="num">2</span>
            <span>品牌</span>
          </p>
          <div class="about_text">公司成立至今，已先后获得多个国际品牌的认可，目前代理品牌主要有意大利BISAZZA艺术马赛克、地板、卫浴，意大利FIR艺术水龙头、意大利WEBERT时尚水龙头，意大利DEVON&DEVON古典卫浴，德国HOESCH豪华按摩浴缸，美国CALDERA户外SPA等。</div>
        </div>
        <div class="about_item">
          <p class="about_title">
            <span class="num">3</span>
            <span>理念</span>
          </p>
          <div class="about_text">我们不仅提供原装进口的卫浴建材产品，更以为客户创造健康、舒适、高品质的卫浴生活方式为我们的价值理念，公司已先后服务于众多私人豪宅客户和酒店会所项目，获得优良口碑。从过去、现在到未来，公司一直专注于卫浴这一领域，立志成为中国领衔的卫浴服务商，为更多中国用户创造健康卫浴生活！</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      isX:false
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .top_banner{
  margin-bottom: 72px;
 }
 .about_title{
  min-width: 98px;
  height: 42px;
  line-height: 42px;
  border-radius: 4px;
  background-color: #f8f7f7;
  color: #000000;
  font-size: 18px;
  margin-bottom: 30px;
  padding-right: 10px;
  display: inline-block;
 }
 .about_item{
  margin-bottom: 46px;
 }
 .num{
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  background-color: #3478f7;
  display: inline-block;
  margin-left: 7px;
 }
 .about_text{
  font-size: 14px;
  color: #000000;
  line-height: 200%;
 }
</style>


// WEBPACK FOOTER //
// src/components/about_us.vue